import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { Context } from '../storage/MainContext'
import { useNavigate } from 'react-router-dom'
import CFirebase from '../configs/Firebase'
import Spinner from '../components/Spinner'

const Login = () => {
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState({
    email: '',
    password: '',
  })
  const { user, setUser } = useContext(Context)
  const navigate = useNavigate()
  /**
   * @param
   * @desc handles login form input change.
   */
  const handleChange = (e) => {
    const { name, value } = e.target

    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const auth = CFirebase.auth

  /**
   * @param e
   * @desc signs in user via firebase
   */
  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    signInWithEmailAndPassword(auth, state.email, state.password)
      .then((userCredential) => {
        // Signed in response
        const { email, accessToken } = userCredential.user
        setUser({ email, accessToken })

        setLoading(false)
        window.alert('Signin successful.')
        // ...
      })
      .catch((error) => {
        setLoading(false)
        const errorMessage = error.message
        console.log(errorMessage)
        window.alert('Signin error. ', errorMessage)
      })
  }

  useEffect(() => {
    // check if user has an access token
    if (user?.accessToken) {
      //   redirect to admin home page
      navigate('/')
    }
  }, [navigate, user?.accessToken])

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <CCardGroup>
              <CCard className="p-4 position-relative">
                {loading && (
                  <div
                    className={' d-flex flex-column justify-content-center align-items-center'}
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      left: 0,
                      bottom: 0,
                      backgroundColor: '#ffffffa0',
                      zIndex: 50,
                    }}
                  >
                    <Spinner />
                    <span className={''}>signing in</span>
                  </div>
                )}

                <CCardBody>
                  <CForm onSubmit={handleSubmit}>
                    <h1>Login</h1>
                    <p className="text-medium-emphasis">Sign In to your account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Email"
                        type={'email'}
                        name={'email'}
                        required={true}
                        value={state?.email}
                        onChange={handleChange}
                      />
                    </CInputGroup>

                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        required={true}
                        autoComplete="current-password"
                        name={'password'}
                        value={state?.password}
                        onChange={handleChange}
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs={6}>
                        <CButton type={'submit'} color="primary" className="px-4">
                          Sign in
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
